export const ignoredEventTypes = ['@@redux/INIT', '@@INIT']
export const isIgnoredEventType = (type: string) => {
  for (const ignoredEventType of ignoredEventTypes) {
    if (type.startsWith(ignoredEventType)) {
      return true
    }
  }

  return false
}
